import { createSlice } from "@reduxjs/toolkit"

const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("assets") !== null && localStorage.getItem("assets") !== undefined && localStorage.getItem("assets") !== "") {
    try {
        const parsedData = JSON.parse(localStorage.getItem("assets"));
        data = Array.isArray(parsedData) ? parsedData : [parsedData];
    } catch (error) {
        console.error('Error parsing assets from localStorage:', error);
        data = [];
    }
}

const assetsSlice = createSlice({
    name: "assets",
    initialState: {
        assets: data,
        loading: {
            fetch: false,
            add: false,
            update: false,
            delete: false
        },
        error: null,
        searchTerm: '',
        filterType: 'all',
        filterStatus: 'all',
        filterLocation: 'all',
        sortBy: 'assetNumber',
        sortOrder: 'asc',
        page: 0,
        rowsPerPage: 10,
        selectedAsset: null,
        dialogOpen: false,
        editingAsset: null
    },
    reducers: {
        // Data management
        getdataassets: (state, action) => {
            state.assets = action.payload.data;
            // Save to localStorage
            localStorage.setItem("assets", JSON.stringify(action.payload.data));
        },

        addAsset: (state, action) => {
            state.assets.push(action.payload);
            // Save to localStorage
            localStorage.setItem("assets", JSON.stringify(state.assets));
        },

        updateAsset: (state, action) => {
            const index = state.assets.findIndex(asset => asset._id === action.payload._id);
            if (index !== -1) {
                state.assets[index] = action.payload;
                // Save to localStorage
                localStorage.setItem("assets", JSON.stringify(state.assets));
            }
        },

        deleteAsset: (state, action) => {
            state.assets = state.assets.filter(asset => asset._id !== action.payload);
            // Save to localStorage
            localStorage.setItem("assets", JSON.stringify(state.assets));
        },

        // Loading states
        setLoading: (state, action) => {
            state.loading = { ...state.loading, ...action.payload };
        },

        // Error handling
        setError: (state, action) => {
            state.error = action.payload;
        },

        clearError: (state) => {
            state.error = null;
        },

        // Search and filtering
        setSearchTerm: (state, action) => {
            state.searchTerm = action.payload;
        },

        setFilterType: (state, action) => {
            state.filterType = action.payload;
        },

        setFilterStatus: (state, action) => {
            state.filterStatus = action.payload;
        },

        setFilterLocation: (state, action) => {
            state.filterLocation = action.payload;
        },

        // Sorting
        setSortBy: (state, action) => {
            state.sortBy = action.payload;
        },

        setSortOrder: (state, action) => {
            state.sortOrder = action.payload;
        },

        // Pagination
        setPage: (state, action) => {
            state.page = action.payload;
        },

        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },

        // Dialog management
        setSelectedAsset: (state, action) => {
            state.selectedAsset = action.payload;
        },

        setDialogOpen: (state, action) => {
            state.dialogOpen = action.payload;
        },

        setEditingAsset: (state, action) => {
            state.editingAsset = action.payload;
        },

        // Clear filters
        clearFilters: (state) => {
            state.searchTerm = '';
            state.filterType = 'all';
            state.filterStatus = 'all';
            state.filterLocation = 'all';
        },

        // Logout
        logoutassets: (state, action) => {
            localStorage.clear();
            state.assets = [];
            state.selectedAsset = null;
            state.editingAsset = null;
            state.dialogOpen = false;
            state.error = null;
        },

        // Legacy support
        updateassetsdata: (state, action) => {
            state.assets = action.payload.data;
            localStorage.setItem("assets", JSON.stringify(action.payload.data));
        }
    }
})

export const { 
    getdataassets, 
    addAsset, 
    updateAsset, 
    deleteAsset,
    setLoading,
    setError,
    clearError,
    setSearchTerm,
    setFilterType,
    setFilterStatus,
    setFilterLocation,
    setSortBy,
    setSortOrder,
    setPage,
    setRowsPerPage,
    setSelectedAsset,
    setDialogOpen,
    setEditingAsset,
    clearFilters,
    logoutassets,
    updateassetsdata
} = assetsSlice.actions;

export default assetsSlice.reducer;